import fetchCurrentPackage from './fetch-current-package';

export default {
  fetchCurrentPackage,
};
